import { render, staticRenderFns } from "./PartyVendorLedger.vue?vue&type=template&id=35271d0c"
import script from "./PartyVendorLedger.vue?vue&type=script&lang=js"
export * from "./PartyVendorLedger.vue?vue&type=script&lang=js"
import style0 from "./PartyVendorLedger.vue?vue&type=style&index=0&id=35271d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports